import React, { useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import CustomerViewEdit from "../../components/customer-information/customer-view-edit";
import { customerViewAction } from "../../redux/actions/customer-action";
const EditCustomer = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(customerViewAction(id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setCustomer(data?.data?.[0]);
  };
  const onError = (data) => {
    loading(false);
  };
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title1={customer?.cmr_code}
          title="Edit Customer"
          view={true}
          onclkEditFn={() => navigate(`/edit-customer/${id}`)}
        >
          <CustomerViewEdit page="edit" customer={customer} disabled={false} />
        </InnerLayout>
      )}
    </>
  );
};

export default EditCustomer;
